<template>
  <div style="height:670px;padding:5px;">
    <div style="font-size:7px">
      Average Slot Age: {{stats.averageSlotAge.toFixed(2)}}min
    </div>
    <div>
      <div style="font-weight:bold;font-size:18px;">Hourly Activity</div>
      <line-chart :data="getHourlyChartData()" style="height:300px;padding:0px;"></line-chart>
    </div>
    <div>
      <div style="font-weight:bold;font-size:18px;">Hourly Activity Deltas</div>
      <line-chart :data="getHourlyDeltaChartData()" style="height:300px;padding:0px;"></line-chart>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      stats: {
        deliveries: 0,
        averageSlotAge: 0,
      },
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    computeDeltas(data) {
      const result = {};
      const keys = Object.keys(data);
      const values = Object.values(data);
      for (let i = 0; i < keys.length - 1; i++) {
        result[keys[i]] = values[i] - values[i + 1];
      }
      return result;
    },

    getData() {
      const options = {
        method: 'get',
        url: '/read/updatescheduler_statistics_gtps/v1',
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;

          this.stats.deliveries = res.data.autoStaged - res.data.autoUnstaged - res.data.autoUnstagedDueToHungCount;
          this.stats.autoStaged = res.data.autoStaged;
          this.stats.autoUnstaged = res.data.autoUnstaged;
          this.stats.autoUnstagedDueToHungCount = res.data.autoUnstagedDueToHungCount;
          this.stats.averageSlotAge = res.data.averageSlotAge;

          this.stats.hourlyDeliveries = res.data.hourlyStatistics.deliveries;
          this.stats.hourlyhourlyAlignersAtCurrentVersion = res.data.hourlyStatistics.alignersAtCurrentVersion;
          this.stats.hourlyTruPointsAtCurrentVersion = res.data.hourlyStatistics.truPointsAtCurrentVersion;
          this.stats.hourlyAutoStaged = res.data.hourlyStatistics.autoStaged;
          this.stats.hourlyConnectedCount = res.data.hourlyStatistics.connectedCount;

          this.stats.hourlyDeliveriesDeltas = this.computeDeltas(this.stats.hourlyDeliveries);
          this.stats.hourlyAlignersAtCurrentVersionDeltas = this.computeDeltas(this.stats.hourlyhourlyAlignersAtCurrentVersion);
          this.stats.hourlyTruPointsAtCurrentVersionDeltas = this.computeDeltas(this.stats.hourlyTruPointsAtCurrentVersion);
          this.stats.hourlyConnectedCountDeltas = this.computeDeltas(this.stats.hourlyConnectedCount);
          this.stats.hourlyAutoStagedDeltas = this.computeDeltas(this.stats.hourlyAutoStaged);
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    getHourlyChartData() {
      const result = [];

      result.push({ name: 'Deliveries', data: this.stats.hourlyDeliveries });
      result.push({ name: 'Connected Equipment', data: this.stats.hourlyConnectedCount });
      result.push({ name: 'Tru-Points with Current Software', data: this.stats.hourlyhourlyAlignersAtCurrentVersion });
      //result.push({ name: 'Auto Stage Slots Used', data: this.stats.autoStaged });

      return result;
    },

    getHourlyDeltaChartData() {
      const result = [];

      result.push({ name: 'Deliveries Attempted', data: this.stats.hourlyDeliveriesDeltas });
      result.push({ name: 'Connections from Equipment', data: this.stats.hourlyConnectedCountDeltas });
      result.push({ name: 'Tru-Points Updated to Current Software', data: this.stats.hourlyAlignersAtCurrentVersionDeltas });
      result.push({ name: 'Auto Stage Slots Used', data: this.stats.hourlyAutoStagedDeltas });

      return result;
    },
  },
};
</script>
